import axios from 'axios'

const pmspApi = axios.create({
  baseURL: '/api-stacionar',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

pmspApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export const pmspService = {
  async getTemplateUsageStats(params = {}) {
    const { data } = await pmspApi.get('/api/pmsp/template-usage', { params })
    return data
  },
}
